import { Component } from "@angular/core";
import { SEND_TYPES } from "app/app-config";
import {
  Plan,
  Provisioning,
} from "app/main/pages/customers/plan-consumption/plan-consumption.interface";
import { PlanService } from "app/main/services/plan.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-plan-provisioning",
  templateUrl: "./plan-provisioning.component.html",
  styleUrls: ["./plan-provisioning.component.scss"],
})
export class PlanProvisioningComponent {
  productStyle = {
    [SEND_TYPES.SMS]: {
      icon: "fa-solid fa-comment-sms",
      color: "info",
    },
    [SEND_TYPES.WHATSAPP]: {
      icon: "fa-brands fa-whatsapp",
      color: "success",
    },
    [SEND_TYPES.EMAIL]: {
      icon: "fa-regular fa-bell",
      color: "primary",
    },
    [SEND_TYPES.PUSH]: {
      icon: "fa-regular fa-envelope",
      color: "secondary",
    },
  };
  currentPlan: Plan = null;
  provisionings: Provisioning[] = [];

  constructor(private readonly planService: PlanService) {
    this.getPlan();
  }

  getPlan() {
    this.planService
      .getMyPlan()
      .pipe(take(1))
      .subscribe((res) => {
        console.log("My plan: ", res);
        this.currentPlan = res;
        this.provisionings = res.provisionings;
      });
  }
}
